import { SortDirection } from './subscription';

export type EmailSubscriptionType = 'NEWSLETTER' | 'PROJECT';

/**
 * Row of the admin `GET /email-subscriptions` list. `email` is where the mail goes: the address given when
 * subscribing, or the account's email for a logged-in subscription. `userId`/`userFullName` are set only when
 * the subscription belongs to an account.
 */
export interface EmailSubscriptionListItem {
  id: number;
  subscriptionType: EmailSubscriptionType;
  userId: number | null;
  userFullName: string | null;
  email: string | null;
  projectId: number | null;
  active: boolean;
  unsubscribeReason: string | null;
  createdAt: string;
  updatedAt: string;
}

export type EmailSubscriptionSort = 'CREATED_AT' | 'UPDATED_AT' | 'EMAIL' | 'NAME' | 'TYPE' | 'ACTIVE';

export interface EmailSubscriptionQuery {
  type?: EmailSubscriptionType;
  active?: boolean;
  search?: string;
  /** ISO instants, both inclusive. */
  subscribedFrom?: string;
  subscribedTo?: string;
  sort?: EmailSubscriptionSort;
  direction?: SortDirection;
  page?: number;
  pageSize?: number;
}

export const buildEmailSubscriptionListUrl = (query: EmailSubscriptionQuery): string => {
  const params = new URLSearchParams();
  params.set('page', String(query.page ?? 0));
  params.set('pageSize', String(query.pageSize ?? 25));
  if (query.type) params.set('type', query.type);
  if (query.active !== undefined) params.set('active', String(query.active));
  if (query.search?.trim()) params.set('search', query.search.trim());
  if (query.subscribedFrom) params.set('subscribedFrom', query.subscribedFrom);
  if (query.subscribedTo) params.set('subscribedTo', query.subscribedTo);
  if (query.sort) params.set('sort', query.sort);
  if (query.direction) params.set('direction', query.direction);
  return `/email-subscriptions?${params.toString()}`;
};
